import styled from 'styled-components'

const H3 = styled.h3`
font-size: 15px;
font-weight: 200px;
letter-spacing: 0.7px;
color:#2C272E;
`
export default H3;